import request from "@/utils/request";
import Qs from "qs";

// 住宅列表
export function houseList(data) {
  return request({
    url: "/house/lists",
    method: "post",
    data: Qs.stringify(data),
  });
}
// 添加住宅房屋
export function houseAdd(data) {
  return request({
    url: "/house/add",
    method: "post",
    data: Qs.stringify(data),
  });
}
// 编辑住宅房屋
export function houseEdit(data) {
  return request({
    url: "/house/edit",
    method: "post",
    data: Qs.stringify(data),
  });
}
// 删除住宅房屋
export function houseDel(data) {
  return request({
    url: "/house/del",
    method: "post",
    data: Qs.stringify(data),
  });
}
// 住宅房屋详情
export function houseInfo(data) {
  return request({
    url: "/house/info",
    method: "post",
    data: Qs.stringify(data),
  });
}

// 住宅用户申请列表
export function examine_lists(data) {
  return request({
    url: "/house_user/examine_lists",
    method: "post",
    data: Qs.stringify(data),
  });
}
// 住宅用户申请审核
export function audit(data) {
  return request({
    url: "/house_user/audit",
    method: "post",
    data: Qs.stringify(data),
  });
}
